// File: src/pages/AddProductPage.js (Updated with Image Upload)

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaArrowLeft, FaSave, FaImage } from 'react-icons/fa'; // Import FaImage icon

// Import the required CSS and components
import './AddProductPage.css';
import SideNav from '../components/SideNav';
import useLicenseCheck from "../hooks/useLicenseCheck";
import toast from 'react-hot-toast';

const AddProductPage = () => {
  useLicenseCheck(); //
  
  const navigate = useNavigate();
  // Your original formData state is preserved
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    category: '',
    quantity: '',
    sku: '',
    expiry_date: '',
  });

  // === 1. NEW STATE ADDED for the image file ===
  const [productImage, setProductImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://installmentzone.com/pharmacy/api';

  // Your original handleChange function is preserved
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // === 2. NEW HANDLER for when a file is selected ===
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProductImage(file);
      // Create a URL for the preview
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // === 3. UPDATED handleSubmit function to use FormData ===
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.price || !formData.sku || !formData.quantity) {
      setError('Product Name, Price, SKU, and Quantity are required.');
      return;
    }

    setIsSubmitting(true);
    setError('');

    // We must use FormData to send files along with text data
    const submissionData = new FormData();

    // Append all the text fields from your formData state
    for (const key in formData) {
      submissionData.append(key, formData[key]);
    }

    // Append the image file if one was selected
    if (productImage) {
      submissionData.append('product_image', productImage);
    }

    try {
      // The axios request is now sending FormData instead of JSON
      const token = localStorage.getItem("token");

const response = await axios.post(`${API_BASE_URL}/add_product.php`, submissionData, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

      console.log('Server response:', response.data);

      if (response.data.status === 'success') {
        alert('Product added successfully!');
        navigate('/products');
      } else {
        setError(response.data.message || 'Failed to add product. Please try again.');
      }
    } catch (err) {
  console.error('Error adding product:', err);

  // Check if backend sent a message
  const backendMessage = err.response?.data?.message;
  const status = err.response?.data?.status;

  if (status === "expired") {
    toast.error("Your license has expired. Please renew!");
    localStorage.removeItem("token");
    localStorage.removeItem("rememberEmail");
    localStorage.removeItem("rememberPassword");
    navigate("/renew-license");
    return;
  }

  if (backendMessage) {
    setError(backendMessage);
  } else {
    setError("An error occurred. Please check your connection and try again.");
  }
}
    
    finally {
      setIsSubmitting(false);
    }
  };


  // === 4. UPDATED JSX with the new image field ===
  return (
    <div className="add-product-page-container">
      <SideNav activePage="Products" />
      <main className="add-product-main-content">
        <header className="page-header">
          {/* ... as before ... */}
        </header>

        <div className="content-card">
          <form onSubmit={handleSubmit} className="add-product-form">
            
            {/* New Image Upload Section */}
            <div className="image-upload-group">
              <label className="form-label">Product Image</label>
              <div className="image-preview-container">
                {imagePreview ? (
                  <img src={imagePreview} alt="Product Preview" className="image-preview" />
                ) : (
                  <div className="image-upload-placeholder">
                    <FaImage size={40} />
                    <span>Upload an image</span>
                  </div>
                )}
              </div>
              <input 
                type="file"
                name="product_image"
                accept="image/png, image/jpeg, image/webp"
                onChange={handleImageChange}
                className="form-input-file"
              />
            </div>

            {/* Your original form fields are all preserved */}
            <div className="form-group">
              <label htmlFor="name" className="form-label">Product Name</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="form-input" required />
            </div>
            <div className="form-group">
              <label htmlFor="sku" className="form-label">SKU</label>
              <input type="text" id="sku" name="sku" value={formData.sku} onChange={handleChange} className="form-input" required />
            </div>
            <div className="form-group">
              <label htmlFor="category" className="form-label">Category</label>
              <input type="text" id="category" name="category" value={formData.category} onChange={handleChange} className="form-input" />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="price" className="form-label">Price</label>
                <input type="number" id="price" name="price" step="0.01" value={formData.price} onChange={handleChange} className="form-input" required />
              </div>
              <div className="form-group">
                <label htmlFor="quantity" className="form-label">Quantity</label>
                <input type="number" id="quantity" name="quantity" value={formData.quantity} onChange={handleChange} className="form-input" required />
              </div>
              <div className="form-group">
                <label htmlFor="expiry_date" className="form-label">Expiry Date</label>
                <input type="date" id="expiry_date" name="expiry_date" value={formData.expiry_date} onChange={handleChange} className="form-input" />
              </div>
            </div>

            {error && <p className="form-error-message">{error}</p>}

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              <FaSave />
              {isSubmitting ? 'Saving...' : 'Save Product'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddProductPage;